package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.PermissionType
import kotlinx.serialization.Serializable

@Serializable
enum class UserPermissionContentConnection(private val literal: String) : PermissionType {
	关联脉证到医案("关联脉证到医案"),
	关联脉证到条文("关联脉证到条文");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "user_permission_content_connection"}
	override fun getLiteral(): String {return literal}
}
